import React from 'react';
import { Link } from 'react-router-dom';
import { SourceSystem } from '@atlassian/cssxp-typescommon';
// @ts-ignore
import RefundIcon from '@css-xp/base/assets/img/icon-refund.svg';
import { GloballyAllowedSidebar } from '@atlassian/cssxp-utils-generic';
import { FormattedCurrency, OpenSidebarRow } from '@css-xp/base';
import { Refunds } from '@css-xp/graphtypes';
import { InvoiceRefundStatusLozenge } from './invoice-refund-status-lozenge';
import isEmpty from 'lodash/isEmpty';
import { InvoiceRefundCreditNote } from './invoice-refund-creditnote-lozenge';

interface Props {
  parentColumns: number;
  key: string;
  refund: Refunds;
  hideActions?: boolean;
  isSelected: boolean;
}

export function InvoiceChildRefundRow(props: Props) {
  const { refund, parentColumns, hideActions, isSelected } = props;

  return (
    <OpenSidebarRow
      key={refund.id}
      className={'search-result-child'}
      sidebar={GloballyAllowedSidebar.REFUND_PREVIEW}
      payload={{
        refundId: refund.creditNoteNumber || refund.id,
      }}
      isSelected={isSelected}
    >
      <td
        className="id col-auto"
        style={{ paddingLeft: '16px' }}
        // If hide actions should be one less than when actions shown
        colSpan={parentColumns - (hideActions ? 1 : 2)}
        data-testid="refund-id"
      >
        <Link
          to={`/refunds/${encodeURIComponent(refund.creditNoteNumber || refund.id)}`}
          onClick={(e) => e.stopPropagation()}
          className="avatar-container"
        >
          <img
            //@ts-ignore
            src={RefundIcon}
            className="avatar medium"
            height={'30px'}
            alt="refund"
            style={{ paddingRight: '6px' }}
          />
          {refund.creditNoteNumber || refund.id}
        </Link>
        {refund.sourceSystem === SourceSystem.CCP && refund.status && (
          <span style={{ paddingLeft: '8px' }}>
            {<InvoiceRefundStatusLozenge status={isEmpty(refund.arn) ? 'PENDING' : 'REFUNDED'} />}
          </span>
        )}{' '}
        {/*// @ts-ignore */}
        {refund.type && ( //@ts-ignore
          <span style={{ paddingLeft: '8px' }}>{<InvoiceRefundCreditNote credittype={refund.type} />}</span>
        )}{' '}
      </td>
      <td className="invoice-amount-cell" data-testid="refund-amount">
        {refund.total ? <FormattedCurrency value={refund.total} currency={refund.currency} showCurrencyCode /> : null}
      </td>
      {/* The empty data cell aligns with Invoice Action Items */}
      {!hideActions && <td />}
    </OpenSidebarRow>
  );
}

export default InvoiceChildRefundRow;
